import axios from 'axios';
import { getToken } from '../auth';

const api = axios.create({
  baseURL: import.meta.env.VITE_RISK_MANAGER_API_URL,
});

api.interceptors.request.use(config => {
  const outputConfig = config;

  const token = getToken();
  if (token) {
    outputConfig.headers.Authorization = `Bearer ${token}`;
  }

  return outputConfig;
});

export default api;